import React from "react";
import { Col, Form, Icon, Input, Radio, Row, Upload } from "antd";
import { QaDynamicSelect } from "../../../../components/DynamicList";
import moment from "moment";

export function PersonalInformation({
    imageUrl,
    handleChange,
    loading,
    getFieldDecorator,
    onChangeBirthDate,
    userData,
}) {
    const { fullName, nameToUse, email, habilityAcademic, celphone, phone, nif, gender, birthDate } = userData;

    const uploadButton = (
        <div>
            <Icon type={loading ? "loading" : "plus"} />
            <div className="ant-upload-text">Clique para carregar</div>
        </div>
    );

    return (
        <Row gutter={16}>
            <Col xs={24} md={8} style={{ justifyContent: "center", alignItems: "center" }}>
                <Upload
                    name="avatar"
                    listType="picture-card"
                    className="avatar-uploader"
                    showUploadList={false}
                    onChange={handleChange}
                >
                    {imageUrl ? (
                        <img src={imageUrl} alt="avatar" style={{ width: "100%", maxHeight: 300 }} />
                    ) : (
                        uploadButton
                    )}
                </Upload>
            </Col>
            <Col xs={24} md={16}>
                <Form layout="vertical">
                    <Row gutter={16}>
                        <Col xs={24} md={12}>
                            <Form.Item label="Nome completo">
                                {getFieldDecorator("nome_completo", {
                                    initialValue: fullName,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório",
                                        },
                                    ],
                                })(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label="Nome a utilizar">
                                {getFieldDecorator("nome", {
                                    initialValue: nameToUse,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório",
                                        },
                                    ],
                                })(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label="E-mail">
                                {getFieldDecorator("email", {
                                    initialValue: email,
                                    type: "email",
                                    message: "Este não é um e-mail válido",
                                })(<Input placeholder="E-mail" />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label="Nº de identificação social / fiscal">
                                {getFieldDecorator("nif", {
                                    initialValue: nif,
                                })(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label="Habilitação literária">
                                {getFieldDecorator("habilitacao", {
                                    initialValue: habilityAcademic,
                                })(<QaDynamicSelect name="habilitacao" style={{ maxWidth: "auto" }} />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label="Telemóvel">
                                {getFieldDecorator("tlm", {
                                    initialValue: phone,
                                })(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label="Telefone">
                                {getFieldDecorator("tlf", {
                                    initialValue: celphone,
                                })(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label="Género">
                                {getFieldDecorator("sexo", {
                                    initialValue: gender,
                                })(
                                    <Radio.Group buttonStyle="solid">
                                        <Radio.Button value="Masculino">Masculino</Radio.Button>
                                        <Radio.Button value="Feminino">Feminino</Radio.Button>
                                        <Radio.Button value="Outro">Outro</Radio.Button>
                                    </Radio.Group>
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={8}>
                            <Form.Item label="Data nascimento">
                                <Input
                                    type="date"
                                    defaultValue={birthDate}
                                    onChange={(e) =>
                                        onChangeBirthDate(
                                            e.target.value ? moment(e.target.value).format("YYYY-MM-DD") : ""
                                        )
                                    }
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    );
}
